import React from "react";
import RichEditor from "components/FormElements/RichEditor";

function RichtextMetaProperty(props) {
    return <RichEditor name={props.name} />;
}

export default RichtextMetaProperty;

export const Property = RichtextMetaProperty;

export const Label = "Rich Text/Formatted Text";
